import { DEFAULT_CONFIGS } from "./constants.js";
import { GIPHY_TYPE } from "./types.js";
import { nodeViewRenderers } from "./viewer/node-view-renderers.js";
const pluginGiphy = (config) => {
  return {
    config: { ...DEFAULT_CONFIGS.viewer, ...config },
    type: GIPHY_TYPE,
    nodeViewRenderers
  };
};
export {
  pluginGiphy
};
//# sourceMappingURL=viewer.js.map
